/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_BigInputs */



/**
* | output |
* | --- |
* | "Big event" |
*
* @param {Tournament_Wiz_Kind_BigInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_big = /** @type {((inputs?: Tournament_Wiz_Kind_BigInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_BigInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Grand événement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gran evento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Grande evento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grande evento")
	return /** @type {LocalizedString} */ ("Big event")
});